// extracted by mini-css-extract-plugin
module.exports = {"alk_privacy_content":"AlkPrivacy_alk_privacy_content__1l3V8","item":"AlkPrivacy_item__BCkPZ"};